<template>
  <div :class="cardClass" class="d-flex align-center px-4 py-4 rounded text-body-2">
    <v-icon :size="mobile ? 21 : 25">
      {{ icon }}
    </v-icon>
    <span class="px-1 text-center"> <slot /> </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useDisplay } from "vuetify";

interface Props {
  icon?: string;
  color?: string;
}

const { color = "surface", icon = "mdi mdi-alert-circle" } = defineProps<Props>();

defineOptions({
  name: "TAlert",
});

const { mobile } = useDisplay();

const cardClass = computed(() => `bg-${color} text-on-${color}`);
</script>

<style scoped>
.t-alert--info {
  background-color: #eeeeee !important;
  border-color: #eeeeee !important;
}

.t-alert--info span {
  text-align: left !important;
}
</style>
